export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4747.0bf8ffdc.jpg";